
export const DEFAULT_PROFILE_PICTURES = {
    MALE: 'https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_6.png',
    FEMALE: 'https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_1.png'
  }